import { memo, useState } from "react";
import PropTypes from "prop-types";
import Lomake from "@/components/02-organisms/Lomake";
import { getMaarayksetByTunniste } from "@/helpers/lupa";
import { useLomakedata } from "@/stores/lomakedata";
import {
  useChangeObjects,
  useChangeObjectsByAnchorWithoutUnderRemoval,
  useUnsavedChangeObjects
} from "@/stores/muutokset";
import isEqual from "react-fast-compare";
import { map, dissoc } from "ramda";

const constants = {
  formLocation: ["opiskelijavuodet"]
};

const MuutospyyntoWizardOpiskelijavuodet = memo(
  ({ code, maaraykset, mode, muut, sectionId, title }) => {
    const [muutLomakedata] = useLomakedata({
      anchor: "muut"
    });

    const [, { removeChangeObjectByAnchor, setChanges }] = useChangeObjects();

    //saved,unsaved
    const [changeObjects] = useChangeObjectsByAnchorWithoutUnderRemoval({
      anchor: sectionId
    });

    //unsaved
    const [changeObjects2] = useUnsavedChangeObjects({
      anchor: sectionId
    });
    let updatedChangeObjects;
    if (changeObjects2 !== undefined) {
      updatedChangeObjects = map(dissoc("tila"), changeObjects);
    }

    const opiskelijavuosiMaaraykset = getMaarayksetByTunniste(
      "opiskelijavuodet",
      maaraykset
    );

    // State to manage the toggle
    const [isToggled, setIsToggled] = useState(false);

    const [isDisabled, setisDisabled] = useState(false);

    const muutMaaraykset = getMaarayksetByTunniste("muut", maaraykset);

    const onClearButtonClick = (fromComponent, uuid) => {
      let changes = [
        {
          anchor: fromComponent,
          properties: {
            isDeleted: true,
            metadata: {
              koodiarvo: 5,
              focusWhenDeleted: fromComponent,
              maaraysUuid: uuid
            }
          }
        },
        {
          anchor: fromComponent,
          properties: {
            isValueSet: false,
            applyForValue: 0,
            isValid: false,
            metadata: {
              koodiarvo: 5,
              focusWhenDeleted: fromComponent,
              maaraysUuid: uuid,
              markedForDeletion: true
            }
          }
        }
      ];

      removeChangeObjectByAnchor(fromComponent);
      setChanges(changes, sectionId);
      setIsToggled(prevState => !prevState);
    };

    return muut && muutMaaraykset && opiskelijavuosiMaaraykset ? (
      <Lomake
        anchor={sectionId}
        changeObjects={updatedChangeObjects || changeObjects}
        code={code}
        data={{ muutLomakedata, sectionId, isToggled, isDisabled }}
        isDisabled={isDisabled}
        isReadOnly={isDisabled}
        functions={{
          setisDisabled: setisDisabled,
          setIsToggled: setIsToggled,
          onClearButtonClick: onClearButtonClick
        }}
        formTitle={title}
        isRowExpanded={true}
        mode={mode}
        path={constants.formLocation}
        showCategoryTitles={true}></Lomake>
    ) : null;
  },
  (cp, np) => isEqual(cp, np)
);

MuutospyyntoWizardOpiskelijavuodet.defaultProps = {
  maaraykset: []
};

MuutospyyntoWizardOpiskelijavuodet.propTypes = {
  code: PropTypes.string,
  lupaKohteet: PropTypes.object,
  maaraykset: PropTypes.array,
  mode: PropTypes.string,
  muut: PropTypes.array,
  sectionId: PropTypes.string,
  title: PropTypes.string
};

MuutospyyntoWizardOpiskelijavuodet.displayName =
  "MuutospyyntoWizardOpiskelijavuodet";

export default MuutospyyntoWizardOpiskelijavuodet;
